import i18n from "i18n";

export const errText = (e) =>
  (typeof e?.message === "string" && e.message) ||
  Object.values(e?.message || {}).flat().join(" ") ||
  i18n.t("bookings:errors.generic");
